import { render, staticRenderFns } from "./ProEquip.vue?vue&type=template&id=71d2b30b&scoped=true&"
import script from "./ProEquip.vue?vue&type=script&lang=js&"
export * from "./ProEquip.vue?vue&type=script&lang=js&"
import style0 from "./ProEquip.vue?vue&type=style&index=0&id=71d2b30b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2b30b",
  null
  
)

export default component.exports